import { AIServiceAgentCategoryDto, AIServiceAgentIconColorDto } from '@internal/nimbus-ai';
import { AgentIconKey } from './agent-icon';
import { AiMentionType } from './ai-mentions';

export interface AIAgent {
  id?: string;
  globalId: string;
  title: string;
  description: string;
  systemPrompt: string;
  inputs: AIAgentInputField[];
  sources: AIAgentSource[];
  webSearch: boolean;
  runButtonTitle?: string;
  isDefault?: boolean;
  iconName: AgentIconKey | '';
  iconColor?: AIServiceAgentIconColorDto;
  categories: string[];
  webpageDetails?: boolean;
}

export enum AIAgentInputFieldType {
  TEXT = 'text',
  FILE = 'file',
}

export enum AIAgentTextFieldType {
  SINGLE = 'single',
  MULTI = 'multi',
}

export interface AIAgentInputField {
  id: string;
  label: string;
  type: AIAgentInputFieldType;
  placeholder?: string;
  required: boolean;
  textFieldType?: AIAgentTextFieldType;
  description: string;
}

export enum AIAgentSourceType {
  NOTE = 'note',
  FOLDER = 'folder',
}

export interface AIAgentSource {
  workspaceId: string;
  id: string;
  type: AIAgentSourceType;
  enriched: {
    title: string;
    url: string;
  };
}

export interface AiMentionItem {
  target: AiMentionType;
  targetId: string;
  displayText: string;
  url?: string;
}

export type AiMentionSuggestionGroup = {
  title: string;
  items: AiMentionItem[];
};

export interface AIWebPageDetails {
  url: string;
  title: string;
  text: string;
}

export interface AiAgentCategoriesState {
  categories: AIServiceAgentCategoryDto[];
  selectedId: string;
}
